// extracted by mini-css-extract-plugin
module.exports = {"link":"dece2e673c--link--pkXM5","button":"dece2e673c--button--JlbVe"};